<template>
  <div class="accordion" :class="accordionClasses">
    <div class="accordion-header" @click.prevent="handleHeaderClick">
      <span class="title">
        <font-awesome-icon icon="chevron-right" class="caret" />
        {{ title }}
      </span>
      <StateButtons :value="state" :onlyActiveState="onlyActiveState" @change="stateChange" />
    </div>
    <TransitionExpand>
      <div class="accordion-content" v-if="open">
        <div class="inner">
          <slot>{{ description }}</slot>
        </div>
      </div>
    </TransitionExpand>
  </div>
</template>

<script>
import StateButtons from "@/components/StateButtons.vue";
import TransitionExpand from "@/components/TransitionExpand.vue";

export default {
  name: "Accordion",

  components: {
    StateButtons,
    TransitionExpand
  },

  props: {
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    },
    open: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ""
    },
    onlyActiveState: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    accordionClasses() {
      return {
        open: this.open
      };
    }
  },

  mounted() {
    this.$forceUpdate();
  },

  methods: {
    toggleAccordionState() {
      this.open = !this.open;
    },
    stateChange({ value }) {
      this.$emit("itemStateChange", {
        ...this.item,
        id: this.id,
        state: value
      });
    },
    handleHeaderClick() {
      this.$emit("stateChange", { id: this.id, open: !this.open });
    }
  }
};
</script>

<style scoped lang="scss">
$primary-color: #0056a4;
.accordion {
  background-color: $primary-color;
  color: #fff;
  margin-bottom: 10px;

  &:last-of-type {
    margin-bottom: 0;
  }

  &.open {
    .accordion-header {
      background-color: darken($primary-color, 15%);
    }
    .caret {
      transform: rotate(90deg);
    }
  }
}

.accordion-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  user-select: none;
  text-align: left;
  transition: all 0.2s linear;
  padding: 10px;
  cursor: pointer;

  .caret {
    margin-right: 10px;
    transition: 0.2s linear;
  }

  .title {
    margin: 0;
  }

  .buttons {
    width: 100%;
  }
}

.accordion-content {
  .inner {
    padding: 20px 15px 15px 15px;
    text-align: left;
    font-size: 0.9rem;
  }
}

@media (min-width: 900px) {
  .accordion-header {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .title {
      flex: 1;
    }
  }
}
</style>
